import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Input, Select, Radio, Image, Upload, Divider } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux";
import { uploadSoftInfo } from "../../service/register";

const CollectionCreateForm = ({ initialValues, onFormInstanceReady }) => {
  const { config } = useSelector((state) => state);
  const [form] = Form.useForm();

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState([]);

  const size = 1; // 图片大小限制（MB）
  const width = 0; // 宽度限制（0表示不限制）
  const height = 0; // 高度限制（0表示不限制）

  const { Option } = Select; // Option解构

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 20 },
  };

  const getBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList)
    //  图片移除时清空表单字段
    if (newFileList.length === 0) {
      form.setFieldsValue({
        app_public_picture: '',
      });
    }
  };

  // useEffect(() => {
  //   onFormInstanceReady(form);
  // }, []);

  useEffect(() => {
    onFormInstanceReady(form);

    // 编辑场景初始化图片列表
    if (initialValues?.app_public_picture) {
      form.setFieldsValue({
        app_public_picture: initialValues.app_public_picture
      });
      setFileList([{
        uid: 'initial',
        name: '公众号二维码',
        status: 'done',
        url: initialValues.app_public_picture, // 显示已上传的图片
      }]);
    }
  }, [initialValues, onFormInstanceReady, form]);

  async function handleBeforeUpload(file, fileList) {
    console.log("file is", file);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("上传类型为 JPG/PNG"); // 修复message调用
      return Upload.LIST_IGNORE;
    }

    const isGt30M = (file.size / 1024 / 1024) > size;
    if (isGt30M) {
      message.error(`图片不能大于${size}M!`); // 修复message调用
      return Upload.LIST_IGNORE;
    }

    // 图片尺寸验证（如果width/height有值）
    function isValidSize() {
      return new Promise((resolve) => {
        if (width && height) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function (e) {
            const data = e.target.result;
            const image = new Image();
            image.onload = function () {
              const imgWidth = image.width;
              const imgHeight = image.height;
              if (imgWidth !== width || imgHeight !== height) {
                message.error("图片宽高设置不正确!"); // 修复message调用
                resolve(false);
              } else {
                resolve(true);
              }
            };
            image.src = data;
          };
        } else {
          resolve(true); // 不限制尺寸时直接通过
        }
      });
    }

    const validSize = await isValidSize();
    return (isJpgOrPng && !isGt30M && validSize) || Upload.LIST_IGNORE;
  }

  function customRequest(option) {
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function (e) {
      if (e && e.target && e.target.result) {
        const base64Data = e.target.result.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );

        uploadSoftInfo({
          pic_base64: base64Data,
        })
          .then((res) => {
            const imageUrl = res.pic_url|| res.data?.pic_url || '';            

           if (imageUrl) {
              form.setFieldsValue({ app_public_picture: imageUrl });
              setFileList([{
                ...option.file,
                uid: option.file.uid,
                status: 'done',
                url: imageUrl
              }]);
              message.success("图片上传成功");
            } 
            
            option.onSuccess(res);
          })
          .catch((e) => {
            option.onError(e);
            message.error("上传错误");
          });
      }
    };
  }

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>图片上传</div>
    </button>
  );

  // 电话必填、微信与qq、微信公众号可以写多个，用分号分隔；邮箱必填；公众号二维码图片
  return (
    <Form
      {...layout}
      // layout="horizontal"
      form={form}
      name="form_in_modal"
      initialValues={initialValues}
    >
      <div className="form-modal-content">
        <Form.Item
          name="app_name"
          label="软件名称"
          rules={[
            {
              required: true,
              message: "请输入软件名称!",
            },
          ]}
        >
          <Input
            placeholder="10个汉字内，英文字符不超过20个"
            className="add-form-input"
          />
        </Form.Item>
        <Form.Item
          name="channel"
          label="软件环境"
          initialValue={1}
          rules={[
            {
              required: true,
              message: "Please input the title of collection!",
            },
          ]}
        >
          <Select
            className="form-modal-select"
            style={{ width: 120 }}
            options={[
              { value: 1, label: "正式" },
              { value: 0, label: "测试" },
            ]}
          />
        </Form.Item>
        <Form.Item
          name="callback_url"
          label="回调地址"
          normalize={(value) => value && value.trim()}
          rules={[
            {
              required: true,
              message: "请输入回调地址",
            },
            {
              message: "回调地址错误",
              pattern: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?%#[\]@!\$&'\*\+,;=.]+$/,
            },
          ]}
        >
          <Input
            placeholder="请输入http或者https地址"
            className="add-form-input"
          />
        </Form.Item>
        <Form.Item
          name="app_cate_id"
          label="软件类型"
          rules={[
            {
              required: true,
              message: "请选择软件类型",
            },

          ]}
        >
          <Select className="appinfo-app_cate" placeholder="请选择软件类型！">
            {config?.soft_cate?.map((item, index) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Divider >用户将会通过以下方式联系您</Divider>
        <Form.Item
          name="app_phone"
          label="联系电话"
          rules={[
            {
              required: true,
              message: "请填写联系电话",
            },

          ]}
        >
          <Input
            placeholder='不存在请填写"-"'
            className="add-form-input"
          />
        </Form.Item>

        <Form.Item
          name="app_public_name"
          label="QQ\微信\公众号"
          rules={[
            {
              required: false
            },

          ]}
        >
          <Input className="add-form-input" />
        </Form.Item>
        <Form.Item
          name="app_email"
          label="邮箱"
          rules={[
            {
              required: true,
              message: "请填写邮箱"
            },

          ]}
        >
          <Input className="add-form-input" />
        </Form.Item>

        <Form.Item name="app_public_picture" label="公众号二维码">
          <Upload
            action="/main/plat/v1/softmgr/uploadpic"
            accept=".jpg, .jpeg, .png"
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onChange={handleChange}
            customRequest={customRequest}
            beforeUpload={handleBeforeUpload}
            maxCount={1}
            size={size * 1024 * 1024}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
          {previewImage && (
            <Image
              wrapperStyle={{ display: 'none' }}
              preview={{
                visible: previewOpen,
                onVisibleChange: visible => setPreviewOpen(visible),
                afterOpenChange: visible => !visible && setPreviewImage(''),
              }}
              src={previewImage}
            />
          )}
        </Form.Item>

        <Form.Item name = "remark" label="备注">
          <Input.TextArea rows={4} />
        </Form.Item>

      </div>
    </Form>
  );
};

export default CollectionCreateForm;
